currentuser.onUserLoad( (e) => {
	let user = e.detail.userinfos;

	async function loadCommentForm(){
		const sidebarcommentformcontainers = document.getElementsByClassName("sidebarcommentformcontainer");
		if( sidebarcommentformcontainers != null ){
			for (let i = 0; i < sidebarcommentformcontainers.length; i++) {
				let sidebarcommentformcontainer = sidebarcommentformcontainers[i];
				let contentobjectid = sidebarcommentformcontainer.dataset.contentobjectid;

				return new Promise((resolve, reject) => {
					return fetch( '/compte/comment-getform/'+contentobjectid, {
						cache: "no-store",
						method: "GET",
					}).then( (response) => {
						return response.json();
					}).then( (commentformresponse) => {
						if( commentformresponse.success ){
							sidebarcommentformcontainer.innerHTML = commentformresponse.html;
							[... sidebarcommentformcontainer.querySelectorAll('.form-comment')].map( formEl => {
								addChangeTypeEventHandler(formEl)
								addNoteChangeEventHandler( formEl )
								AddSubmitHandler(formEl)
							});
						}
						resolve();
					}).catch( () => {
						reject( 'Erreur lors du chargement des formulaires de commentaires' );
					});
				});
			}
		}
	}

	async function report( reporturl ){
    return new Promise((resolve, reject) => {
      return fetch( reporturl, {
				cache: "no-store"
			}).then( (response) => {
        return response.json();
      }).then( (responsereport) => {
        if( responsereport.success ){
          resolve( responsereport.message );
        } else {
          reject( responsereport.message );
        }
      }).catch( (error) => {
				console.log( 'comment:report', error );
        reject( 'Erreur lors de l\'envoi de votre signalement' );
      });
    });
  }

  async function like( reporturl ){
    return new Promise((resolve, reject) => {
      return fetch( reporturl, { 
				cache: "no-store" 
			}).then( (response) => {
        return response.json();
      }).then( (responsereport) => {
        if( responsereport.success ){
          resolve( responsereport.message );
        } else {
          reject( responsereport.message );
        }
      }).catch( (error) => {
				console.log( 'comment:like', error );
        reject( 'Erreur lors de l\'envoi de votre like' );
      });
    });
  }

	async function submit( formurl, formdatas ){
    return new Promise((resolve, reject) => {
      return fetch( formurl, {
				cache: "no-store",
        method: "POST",
        body: formdatas,
      }).then( (response) => {
        return response.json();
      }).then( (responsecomment) => {
        if( responsecomment.success ){
          resolve( responsecomment.message );
        } else {
          reject( responsecomment.message );
        }
      }).catch( (error) => {
				console.log( 'comment:submit', error );
        reject( 'Erreur lors de l\'envoi de votre commentaire' );
      });
    });
  }

	//envoi d'un commentaire
	async function AddSubmitHandler(formEl){
		formEl.addEventListener( 'submit', function (event) {
			event.preventDefault();

			let actionurl = formEl.getAttribute('action');

			// empty old messages
			[... formEl.querySelectorAll('.alert')].map( alert => alert.remove() );

			let formDatas = new FormData(formEl);

			// add note to formDatas
			let note = 5;
			[... formEl.querySelectorAll('.note')].map( noteel => {
				if( noteel.classList.contains('active') ){
					note = noteel.dataset.value;
				}
			});
			formDatas.append( 'note', note );

			[... formEl.querySelectorAll('.comment-answer-authorname')].map( input => {
				if( input.value.trim() == '' ){
					let alert = document.createElement( 'p' );
					alert.classList.add( 'alert' );
					alert.classList.add( 'alert-danger' );
					alert.innerHTML = 'Pseudo est obligatoire';
					formEl.apppend( alert );
				}
			});

			[... formEl.querySelectorAll('.comment-answer-content')].map( input => {
				if( input.value.trim() == '' ){
					let alert = document.createElement('p');
					alert.classList.add( 'alert' );
					alert.classList.add( 'alert-danger' );
					alert.innerHTML = 'Le commentaire est obligatoire';
					formEl.append( alert );
				}
			});

			if( formEl.querySelectorAll('.alert').length == 0 ){
				[... formEl.querySelectorAll('.send-comment')].map( button => {
					button.setAttribute('disabled', true );
					button.style.cursor = 'wait';
				});

				submit( actionurl, formDatas ).then( ( message ) => {
          let alert = document.createElement('p');
					alert.classList.add( 'alert' );
					alert.classList.add( 'alert-success' );
					alert.innerHTML = message;
          formEl.append( alert );
					//remove active in 2 seconds
					setTimeout( function(){
						[... formEl.querySelectorAll('.send-comment')].map( button => {
							button.removeAttribute('disabled');
							button.style.cursor = 'pointer';

              [... formEl.querySelectorAll('.comment-answer-content')].map( input => {
                input.value = '';
              });


						});
					}, 2000);
        }).catch( (error) => {
					let alert = document.createElement('p');
					alert.classList.add( 'alert' );
					alert.classList.add( 'alert-danger' );
					alert.innerHTML = error;
          formEl.append( alert );
					//remove active in 2 seconds
					setTimeout( function(){
						[... formEl.querySelectorAll('.send-comment')].map( button => {
							button.removeAttribute('disabled');
							button.style.cursor = 'pointer';
						});
					}, 2000);
        });
			}
		});
	}

	// Change type
	async function addChangeTypeEventHandler( formEl ){
		[... formEl.querySelectorAll('.comment-type')].map( i => {
			i.addEventListener( 'change', function (e) {
				[... formEl.querySelectorAll('.form-comment')].map( formEl => {
					if( i.checked ){
						[... formEl.querySelectorAll('.label-usertype')].map( label => label.innerHTML = 'Prénom et âge de votre enfant <span class="required">*</span>:' );
					} else {
						[... formEl.querySelectorAll('.label-usertype')].map( label => label.innerHTML = 'Votre prénom ou pseudo <span class="required">*</span>:' );
					}
				});
			});
		});
	}

	async function addNoteChangeEventHandler( formEl ){
		[... formEl.querySelectorAll('.note')].map( i => {
			i.addEventListener( 'click', function (e) {
				let max = i.dataset.value;
				[... document.querySelectorAll('.note')].map( j => {
					if( j.dataset.value <= max )
					{
						j.classList.add('active');
					}
					else
					{
						j.classList.remove('active');
					}
				});
			});
		});
	}

	// Show all Comments
	[... document.querySelectorAll('.comments')].map( commentListEl => {
		[... commentListEl.querySelectorAll('.showallcomments')].map( j => {
			j.addEventListener( 'click', function (e) {
				[... commentListEl.querySelectorAll('ul')].map( k => k.classList.add('showall') );
				[... commentListEl.querySelectorAll('.showallcomments-container')].map( k => k.remove() );
			});
		});

		[... commentListEl.querySelectorAll('.comment')].map( currentCommentEl => {
			// reply on a comment
			[... currentCommentEl.querySelectorAll('.reply')].map( k => {
				k.addEventListener( 'click', function (event) {
					event.preventDefault();
					[... commentListEl.querySelectorAll('.comment .comment-answer')].map( l => l.remove() );
					let itemid = k.dataset.itemid;
					let commentid = k.dataset.commentid;
					let respondboxid = 'comment-answer-' + itemid + '-' + commentid;
					let respondbox = document.getElementById( respondboxid );
					let answerbox = document.getElementById( 'comment-answer' );
					if( !respondbox ){
						let commentbox = answerbox.cloneNode(true);
						commentbox.id = respondboxid;
						currentCommentEl.appendChild(commentbox);

						[... currentCommentEl.querySelectorAll('#'+respondboxid+' h3')].map( l => l.text = 'Répondre au commentaire' );
						[... currentCommentEl.querySelectorAll('#'+respondboxid+' .comment-parent-id')].map( l => l.value = commentid );

						[... currentCommentEl.querySelectorAll('.form-comment')].map( formEl => {

							addChangeTypeEventHandler(formEl)
							addNoteChangeEventHandler(formEl)
							AddSubmitHandler(formEl)
						});
					}
				});
			});


      [... currentCommentEl.querySelectorAll('.like')].map( k => {
				k.addEventListener( 'click', function (event) {
					event.preventDefault();

         [... k.querySelectorAll('.tooltip-like')].map( tooltip => tooltip.remove() );

          if( user.loggedin == true )
          {
            let commentid = k.dataset.commentid;
            like( '/comment-like/'+commentid ).then( ( message ) => {
              k.querySelector('.count').innerHTML  = message;
            }).catch( (error) => {
            });
          } else {
            let msglike = document.createElement('span');
            msglike.classList.add( 'tooltip-like' );
            msglike.innerHTML = 'Veuillez vous connecter pour aimer le commentaire';
            k.append(msglike);
          }

				});
			});

			// report as abusive
			[... currentCommentEl.querySelectorAll('.report-comment')].map( reportitem => {
				let reportlink = reportitem;
				reportlink.addEventListener( 'click', function (event) {
					event.preventDefault();
					let commentid = reportlink.dataset.commentid;
					if( commentid ){
						let modalID = 'modalreports'
						let modalEl = document.getElementById( modalID );
						if( !modalEl ){
							let reportModal = document.createElement('div');
				      reportModal.id = modalID;
				      reportModal.innerHTML = '<div class="modalheader">Signalement d\'un commentaire</div>' +
																			'<div class="modalcontent">' +
																				'<p><strong>Nous vous rappelons ci-dessous les règles concernant les commentaires jugés comme abusifs:</strong></p>' +
																				'<ul class="modalrules">' +
																					'<li>Les Contributions ne doivent pas porter atteinte ou être contraires à l\'ordre public, aux bonnes mœurs ni heurter la sensibilité des mineurs</li>' +
																					'<li>Les Contributions ne doivent pas porter atteinte de quelque manière que ce soit aux droits à la réputation, à la vie privée de tiers et à l\'image de ces derniers</li>' +
																					'<li>Les Contributions ne doivent pas être dénigrantes, diffamatoires, injurieuses, obscènes, violentes, racistes, xénophobes, porter atteinte à l\'image et à la réputation d\'une marque ou d\'une quelconque personne physique ou morale, de quelque manière que ce soit</li>' +
																					'<li>Les Contributions ne doivent pas être utilisées à des fins de menaces ou d\’harcèlement, de quelque manière que ce soit</li>' +
																					'<li>Les Contributions ne doivent pas inciter à la haine, à la violence, au suicide, au racisme, à l\'antisémitisme, à la xénophobie, à l\’homophobie, faire l\'apologie des crimes de guerre ou des crimes contre l\'humanité</li>' +
																					'<li>Les Contributions ne doivent pas inciter à la discrimination d\'une personne ou d\'un groupe de personne en raison de son appartenance à une ethnie, à une religion, à une race, ou du fait de son orientation sexuelle ou de son handicap</li>' +
																					'<li>Les Contributions ne doivent pas inciter à commettre un crime, un délit ou un acte de terrorisme</li>' +
																					'<li>Les Contributions ne doivent pas présenter de caractère pornographique ou pédophile</li>' +
																					'<li>Les Contributions ne doivent pas porter atteinte à la sécurité ou à l\'intégrité d\'un Etat ou d\'un territoire, quel qu\'il soit</li>' +
																					'<li>Les Contributions ne doivent pas porter atteinte aux droits de propriété intellectuelle de quelque personne que ce soit.</li>' +
																				'</ul>' +
																			'</div>' +
																			'<div class="modalactions">' +
																				'<a class="btn cancel">Annuler</a>' +
																				'<a class="btn button-disabled confirm">Confirmer</a>' +
																			'</div>';
							document.body.append( reportModal );
						}

						modalEl = document.getElementById( modalID );
						if( modalEl ){
							[... modalEl.querySelectorAll('.cancel')].map( l => {
								l.addEventListener( 'click', function (cancelreportclickevent) {
									cancelreportclickevent.preventDefault();
									modalEl.remove();
								});
							});

							[... modalEl.querySelectorAll('.modalrules')].map( l => {
								l.addEventListener( 'scroll', function (evscroll) {
									let element = evscroll.target;
									if (element.scrollHeight - element.scrollTop === element.clientHeight)
									{
										[... modalEl.querySelectorAll('.confirm')].map( m => {
											m.classList.remove('button-disabled');
											m.addEventListener( 'click', function ( confirmreportclickevent ) {
												confirmreportclickevent.preventDefault();
												report( '/comment-report/'+commentid ).then( ( message ) => {
													let reportLinkText = document.createElement('span');
													reportLinkText.innerHTML = message;
													reportlink.replaceWith( reportLinkText );
													modalEl.remove();
												}).catch( (error) => {
													modalEl.remove();
												});
											});
										});
									}
								});
							});
						}
					}
				});
			});

		});
	});




	// sidebarcomments togglers
	[... document.querySelectorAll('.sidebarcommentstoggler')].map( sidebarcommentstogglerEl => {
		sidebarcommentstogglerEl.addEventListener( 'click', (event) => {
			event.preventDefault();
      if( sidebarcommentstogglerEl.dataset.target && document.querySelector( sidebarcommentstogglerEl.dataset.target ) ){
        if( document.querySelector( sidebarcommentstogglerEl.dataset.target ).classList.contains( 'show' ) ){
          document.querySelector( sidebarcommentstogglerEl.dataset.target ).classList.remove( 'show' );
          document.documentElement.classList.remove( 'sidebarcommentsopened' );
          [... document.querySelectorAll('.sidebarcommentstoggler')].map( sidebarcommentstogglerbisEl => {
            sidebarcommentstogglerbisEl.setAttribute('aria-expanded', "false" );
            sidebarcommentstogglerbisEl.classList.add('collapsed');
          });
        } else {
          document.querySelector( sidebarcommentstogglerEl.dataset.target ).classList.add( 'show' );
          document.documentElement.classList.add( 'sidebarcommentsopened' );
          [... document.querySelectorAll('.sidebarcommentstoggler')].map( sidebarcommentstogglerbisEl => {
            sidebarcommentstogglerbisEl.setAttribute('aria-expanded', "true" );
            sidebarcommentstogglerbisEl.classList.remove('collapsed');
          });
					loadCommentForm();
        }
      }
    });
	});

  //sidebarcomments overlay click
  let sidebarcommentsmaindiv = document.querySelector( '#sidebarcomments' );
  let sidebarcommentscontentdiv = (sidebarcommentsmaindiv) ? sidebarcommentsmaindiv.querySelector( '.sidebarcomments-content'):null;
  if( sidebarcommentsmaindiv && sidebarcommentscontentdiv ){
    sidebarcommentsmaindiv.addEventListener( 'click', (event) => {
      let inSidebarcommentsContent = ( event.target == sidebarcommentscontentdiv );

      if( event.srcElement.classList.contains('showallcomments') ){
        inSidebarcommentsContent = true;
      }

      if( event.target != sidebarcommentscontentdiv && event.target.parentNode ){
        let parent = event.target.parentNode;

        while( parent != null ) {
          if ( parent.parentNode == sidebarcommentscontentdiv ) {
            inSidebarcommentsContent = true;
          }
          parent = parent.parentNode;
        }
      }

      if( !inSidebarcommentsContent ){
        if( sidebarcommentsmaindiv.classList.contains( 'show' ) ){
          sidebarcommentsmaindiv.classList.remove( 'show' );
          document.documentElement.classList.remove( 'sidebarcommentsopened' );
          [... document.querySelectorAll('.sidebarcommentstoggler')].map( sidebarcommentstogglerbisEl => {
            sidebarcommentstogglerbisEl.setAttribute('aria-expanded', "false" );
            sidebarcommentstogglerbisEl.classList.add('collapsed');
          });
        }
      }
    });
  }

});